<template>
  <a class="">
    <slot />
  </a>
</template>
